import React, { useEffect, useState } from 'react';

const SplashScreen = () => {
  const [fade, setFade] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const timer = setTimeout(() => setFade(true), 2000);
    
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <style>
        {`
          @keyframes splashPulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.02); opacity: 0.9; }
            100% { transform: scale(1); opacity: 1; }
          }
          
          @keyframes splashLoading {
            0% { transform: translateX(-150%); }
            100% { transform: translateX(250%); }
          }
          
          .splash-logo {
            animation: splashPulse 2s infinite;
          }
          
          .splash-loading-bar::after {
            content: '';
            display: block;
            width: 30%;
            height: 100%;
            background: linear-gradient(90deg, #ff9800, #f57c00);
            animation: splashLoading 1.2s infinite ease-in-out;
            border-radius: 4px;
          }
        `}
      </style>
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        background: 'linear-gradient(135deg, #ffffff, #f8f9fa)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'opacity 0.5s ease-out',
        opacity: fade ? 0 : 1,
        zIndex: 1000,
        padding: screenWidth <= 480 ? '20px' : '40px'
      }}>
        {/* Logo */}
        <img 
          src="/assets/orangeatt.png" 
          alt="Logo" 
          className="splash-logo"
          style={{
            width: screenWidth <= 480 ? '150px' : screenWidth <= 768 ? '180px' : '200px',
            height: screenWidth <= 480 ? '60px' : screenWidth <= 768 ? '75px' : '85px',
            objectFit: 'contain',
            borderRadius: '14px',
            marginBottom: screenWidth <= 480 ? '15px' : '20px',
            filter: 'contrast(1.05) brightness(1.02) drop-shadow(0 5px 15px rgba(240, 73, 21, 0.2))'
          }}
        />

        {/* Loading Bar */}
        <div 
          className="splash-loading-bar"
          style={{
            width: screenWidth <= 480 ? '120px' : '140px',
            height: '2px',
            background: 'rgba(0, 0, 0, 0.05)',
            borderRadius: '4px',
            marginTop: '1px',
            overflow: 'hidden',
            position: 'relative'
          }}
        />

        {/* Powered By Section */}
        <div style={{
          position: 'absolute',
          bottom: screenWidth <= 480 ? '30px' : '40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: screenWidth <= 480 ? '6px' : '8px'
        }}>
          <span style={{
            fontSize: screenWidth <= 480 ? '10px' : '12px',
            color: '#666',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            fontWeight: '500',
            fontFamily: 'Outfit, sans-serif'
          }}>
            Powered By
          </span>
          <img 
            src="/assets/textonly.png" 
            alt="Powered By Logo"
            style={{
              width: screenWidth <= 480 ? '150px' : '200px',
              height: 'auto',
              opacity: '0.8',
              transition: 'opacity 0.3s ease',
              padding: screenWidth <= 480 ? '6px 10px' : '8px 12px',
              borderRadius: '6px'
            }}
            onMouseEnter={(e) => e.target.style.opacity = '1'}
            onMouseLeave={(e) => e.target.style.opacity = '0.8'}
          />
        </div>
      </div>
    </>
  );
};

export default SplashScreen;

